import { render, staticRenderFns } from "./RadioInput2.vue?vue&type=template&id=06269c4c&"
import script from "./RadioInput2.vue?vue&type=script&lang=ts&"
export * from "./RadioInput2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports